import { render, staticRenderFns } from "./ImgMove.vue?vue&type=template&id=2f5f68e9&scoped=true"
import script from "./ImgMove.vue?vue&type=script&lang=js"
export * from "./ImgMove.vue?vue&type=script&lang=js"
import style0 from "./ImgMove.vue?vue&type=style&index=0&id=2f5f68e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5f68e9",
  null
  
)

export default component.exports